import {Tooltip} from 'antd';

export const textHelpers = {
  containsMarkdown: (text) => {
    if (typeof text !== 'string') return false;
    const markdownPatterns = [
      /(^|\s)\*{1,2}[^*]+\*{1,2}($|\s)/,         // *italic* or **bold**
      /(^|\s)_[^_]+_($|\s)/,                     // _italic_
      /(^|\n)#{1,6}\s.+/,                        // # Header
      /(^|\n)(\*|-|\+)\s.+/,                     // Unordered list: *, -, +
      /(^|\n)\d+\.\s.+/,                         // Ordered list: 1. item
      /`[^`]+`/,                                 // Inline code: `code`
      /```[\s\S]*?```/,                          // Code block: ``` code ```
      /\[.+\]\(.+\)/,                            // Links: [text](url)
      /^> .+/,                                   // Blockquote: > text
    ];

    return markdownPatterns.some((pattern) => pattern.test(text));
  },
  cutString: (string, maxLengthName = 15) =>
    string ? string.length <= maxLengthName ? string : `${string.substring(0, maxLengthName)}...` : '',
  findStringDifference: (str1, str2) => str2[[...str1].findIndex((el, index) => el !== str2[index])],
  getCapitalized: (word) => word ? `${word.charAt(0).toUpperCase()}${word.slice(1)}` : word,
  getInitials: (string, useOneInitialLetter = false) => {
    if (string === null || string === undefined) {
      return '';
    }
    let names = string.split(' '),
      initials = names[0].substring(0, 1).toUpperCase(),
      namesLength = names.length;

    if (namesLength > 1) {
      initials += names[namesLength - 1].substring(0, 1).toUpperCase();
    } else if (namesLength === 1 && !useOneInitialLetter) {
      initials += string.slice(1, string.length - 1).substring(0, 1).toUpperCase()
    }
    return initials;
  },
  getFilenameFromUrl: (url) => {
    try {
      const cleanUrl = new URL(url);
      const pathname = cleanUrl.pathname;
      return pathname.substring(pathname.lastIndexOf('/') + 1);
    } catch (e) {
      return null;
    }
  },
  reverse: (str) => str.split('').reverse().join(''),
  separateString: (str, separateSymbol) => {
    str = textHelpers.reverse(str);
    str = str.match(/.{1,3}/g).join(' ');
    str = textHelpers.reverse(str);
    if (separateSymbol !== ' ') {
      str = str.replaceAll(' ', separateSymbol);
    }
    return str;
  },
  getTextDigits: (text) => text.replace(/\D/g,''),
  getNameParts: (fullName = '') => {
    let parts = fullName.trim().split(' ');
    let firstName = parts[0];
    let lastName = parts.length > 1 ? parts[parts.length - 1] : '';
    return {
      firstName: firstName,
      lastName: lastName
    };
  },
  roundToTwo: (val) => {
    const n = Number(val);
    if (Number.isNaN(n)) return val;
    return Number(n.toFixed(2));
  },
  getTextWithTooltip: (text, maxLength = 20) => {
    if (typeof text !== 'string') return text;
    if (text.length <= maxLength) return text;
    const truncatedText = text.substring(0, maxLength) + '...';
    return (
      <Tooltip title={text} classNames={{root: 'tooltip-with-text'}}>
        <span>{truncatedText}</span>
      </Tooltip>
    );
  }
}
